import { render, staticRenderFns } from "./AvatarDropdown.vue?vue&type=template&id=8669d18e&scoped=true&"
import script from "./AvatarDropdown.vue?vue&type=script&lang=js&"
export * from "./AvatarDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AvatarDropdown.vue?vue&type=style&index=0&id=8669d18e&lang=less&scoped=true&"
import style1 from "./AvatarDropdown.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8669d18e",
  null
  
)

export default component.exports